// Calculate read time from a flat text payload (in words) at 200 wpm,
// matching BlogOverlayImg's calculateReadTime function.
const calculateReadTimeFromText = (text) => {
  if (!text) return null;
  const words = text
    .trim()
    .split(/\s+/)
    .filter(Boolean).length;
  return Math.max(1, Math.ceil(words / 200));
};

export const transformSanityToHomepageFormat = (sanityPosts) => {
  return sanityPosts.map((post) => {
    // Prefer the read time computed from the actual body text. The Sanity
    // `readTime` field is a hand-set value and can drift out of sync with
    // the real post content.
    const computedReadTime = calculateReadTimeFromText(post.bodyText);
    return {
      _id: post._id,
      slug: post.slug,
      category: post.categories || [],
      img: post.mainImage?.asset?.url || '',
      title: post.title || '',
      excerpt: post.excerpt || '',
      body: [],
      date: post.publishedAt ? new Date(post.publishedAt).toISOString().split('T')[0] : '',
      readTime: computedReadTime ?? post.readTime ?? 5,
      likes: post.claps || 0,
    };
  })
}
